import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { IOrderOriginPaginatedResponse } from './order.types'

export class Order extends ServiceBase {
  private mainURL = '/order'

  public async origins(
    invoiceId: string,
    page: number,
  ): Promise<IOrderOriginPaginatedResponse> {
    const url = `${this.mainURL}/origins/${invoiceId}`

    const response = await this.request.get<
      IOrderOriginPaginatedResponse,
      IError
    >(url, {
      params: {
        page,
        limit: 10,
      },
    })

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
